import AnalyticsJI from "./services/AnalyticsJI.js";
import Achievements from "./services/Achievements.js";
import Localization from "./services/Localization.js";
import MarketPlace from "./services/MarketPlace.js";
import RateApp from "./services/RateApp.js";
import EmailFeedback from "./services/EmailFeedback.js";
import Share from "./services/Share.js";
import Device from "./services/Device.js";
import Prompter from "./services/Prompter.js";
import Storage from "./services/Storage.js";
import FBInstantGame from "./services/FBInstantGame.js";

import AppConfig from "./configs/AppConfig.js";
import AchievementConfig from './configs/AchievementConfig.js'
import LocalizationConfig from "./configs/LocalizationConfig.js";

export default class App {

  constructor() {
    this.userdata = {};
    this.config = AppConfig;
    this.pageId = 'Loading';
    this.onNavigate = function (path) { };
    this.onNotification = function (model) { };
    this.onPopUp = function (model, template) { };
    this.debug = this.config.debug;
    this.version = this.config.version;

    //libraries
    this.device = new Device();
    this.localization = new Localization(LocalizationConfig);
    this.marketPlace = new MarketPlace(AppConfig.appName);
    this.rateApp = new RateApp(AppConfig);
    this.emailFeedback = new EmailFeedback(AppConfig);
    this.sharer = new Share(AppConfig);
    this.analyticsJI = new AnalyticsJI(AppConfig);
    this.achievements = new Achievements(AchievementConfig);
    this.achievements.onNewAchievement = this.onNewAchievement.bind(this);
    this.prompter = new Prompter(AppConfig);
    this.prompter.onPrompt = this.onPrompt.bind(this);
    this.storage = new Storage(AppConfig);
    this.FBInstantGame = new FBInstantGame();

    //get default resource
    this.resource = this.localization.getResource();

    //get device info
    this.os = this.device.getOS();
    this.platform = this.device.getPlatform();
    this.browser = this.device.getBrowser();


    this.load();
  }

  async load() {
    this.navigate('Loading');

    //load userdata
    const data = await this.storage.load('gin.userdata');
    if (data) this.userdata = data;

    //facebook init and load data
    await this.loadFacebookData();

    //set localization resource based on user settings
    if (this.userdata.language) {
      this.resource = this.localization.getResource(this.userdata.language);
    }

    //tracking
    this.analyticsJI.TrackStart();
    //todo: firebase track user

    //ask to rate / share
    this.prompter.delayedPrompt();

    //save os in profile
    this.userdata.os = this.device.getOS();
    this.userdata.platform = this.device.getPlatform();
    this.userdata.browser = this.device.getBrowser();
    this.userdata.version = this.version;

    //log game opened
    this.userdata.game_open = (this.userdata.game_open || 0) + 1;
    if (!this.userdata.first_open) this.userdata.first_open = Date.now();

    //check for achievements
    this.achievements.checkForAchievementAndReward(this.userdata, this.userdata);

    //todo: IAP

    //todo: Push Notifications

    //todo:black list check

    //set up ads
    //todo: this.advertisement.setUp();
    //todo: requestTrackingAuthorizationWithExplainer() with explainer text;


    this.navigate('MainMenu');
  }
  navigate(path) {
    this.pageId = path;

    //trigger UI contollers
    if (this.onNavigate) this.onNavigate(path);

    this.navigated(path);
  }
  navigated(path) {
    if (path == "") path = "MainMenu";
    console.log('navigated', path);

    //todo: firebase track page;

    if (path == "MainMenu") {
      this.showAd();
      this.save();
    }
    if (path == "ComputerMenu") {
      this.showAd();
      this.save();
    }
    if (path == "OnlineMenu") {
      this.showAd();
      this.save();
    }
  }

  onNewAchievement(achievements) {
    //this.showAchievementPopup(achievements);
    this.save();
    for (let i = 0; i < achievements.length; i++) {
      const achievement = achievements[i];
      this.showNotification({
        title: achievement.title,
        description: achievement.description,
        image: "assets/Achievements/" + achievement.image,
        points: achievement.points,
        type: "Achievement"
      });
    }

  }
  save() {
    this.storage.save('gin.userdata', this.userdata);
    this.FBInstantGame.saveData(this.userdata);
  }
  showAd() { }
  rateGame() {
    this.achievements.awardAchivement(this.userdata, "Rate Game");
    let results = this.rateApp.rate();
    if (!results) this.share();
  }
  email() {
    this.achievements.awardAchivement(this.userdata, "Send Feedback");
    this.emailFeedback.send(this.userdata);
  }
  share() {
    this.achievements.awardAchivement(this.userdata, "Share Game");
    this.sharer.share();
  }
  delay(n) {
    return new Promise(function (resolve) {
      setTimeout(resolve, n * 1000);
    });
  }
  showNotification(model) {
    //Basic - { message: "Message", type: "Basic" }
    //Achievement - { message: "Test", description: "Something more", points: 25, type:"Achievement" }
    if (typeof model === "string") model = { message: model, type: "Basic" };
    if (this.onNotification) this.onNotification(model);
  }
  showPopUp(model, template) {
    if (this.onPopUp) this.onPopUp(model, template);
  }
  showEnjoyGame(message) {
    if (!message) message = "Having fun?";
    this.showPopUp({ message: message, onYes: this.showAskRate.bind(this) }, "YesNoDialog");
  }
  showShare(message) {
    if (!message) message = "Share the app?";
    this.showPopUp({ message: message, onYes: this.share.bind(this) }, "YesNoDialog");
  }
  showAskRate(message) {
    if (!message) message = "Rate the app?";
    this.showPopUp({ message: message, onYes: this.rateGame.bind(this) }, "YesNoDialog");
  }
  onPrompt(message, os) {
    if (os == "FBMessenger") {
      this.showShare(message);
    }
    else {
      //ask if like game then ask to rate
      this.showEnjoyGame(message);
    }
    this.rateApp.rateNative();
  }
  async loadFacebookData() {
    if (!this.FBInstantGame.isOnFacebook) return;
    await this.FBInstantGame.initialize();

    //load fb user data if no local data
    if (!this.userdata || JSON.stringify(this.userdata) == '{}') {
      let fbUserData = await this.FBInstantGame.loadData("userdata");
      if (fbUserData) this.userdata = fbUserData;
    }
    //load fb profile data
    let fbProfile = await this.FBInstantGame.getProfile();
    if (fbProfile) {
      if (fbProfile.id) this.userdata.facebookId = fbProfile.id;
      if (!this.userdata.name && fbProfile.name) this.userdata.name = fbProfile.name;
      if (!this.userdata.avatar && fbProfile.pic) this.userdata.avatar = fbProfile.pic;
      if (fbProfile.pic) this.userdata.avatar_facebook = fbProfile.pic;
      if (!this.userdata.locale && fbProfile.locale) this.userdata.locale = fbProfile.locale;
    }
    //check for invites
    let invite = await this.FBInstantGame.getInvite();
    if (invite) {
      this.showNotification("You have been invited to play a game");
    }
  }
}